module.exports = __webpack_public_path__ + "img/u311.3f98f8a5.svg";